import { orderConstants } from './orderConstants';
import OrdersService from '../../../components/dashboard/ordersService';
import cacheRefresherActions from '../cacheRefresher/cacheRefresherActions';
import cacheRefresherConstants from '../cacheRefresher/cacheRefresherConstants';
import loadingActions from '../loading/loadingActions';
import FractionService from '../../../services/fractionService';

export function getOrders(
  date,
  ignoreCache = false,
  silent = false,
  customerIds = [],
  fractionIds = []
) {
  return (dispatch) => {
    const timestamp = Date.now();

    dispatch(
      cacheRefresherActions.addRequestInProgress(orderConstants.GET_ORDERS)
    );
    if (!silent) {
      dispatch(loadingActions.addLoadingInProgress(orderConstants.GET_ORDERS));
    }

    dispatch(
      cacheRefresherActions.setCacheRefreshFilter({
        date,
        requestType: cacheRefresherConstants.REQUEST_TYPE_ORDERS,
      })
    );

    const headPromise = OrdersService.getOrderHeadsByAndDate(
      date,
      ignoreCache,
      customerIds,
      fractionIds
    );
    const detailsPromise = OrdersService.getOrderDetailsByDate(
      date,
      ignoreCache,
      customerIds,
      fractionIds
    );
    let allRequestsPromise;

    if (!silent) {
      allRequestsPromise = Promise.all([
        headPromise.then((orderHeads) =>
          dispatch(orderHeadsLoaded(orderHeads, timestamp))
        ),
        detailsPromise.then((orderDetails) =>
          dispatch(orderDetailsLoaded(orderDetails, timestamp))
        ),
      ]);
    } else {
      allRequestsPromise = Promise.all([headPromise, detailsPromise]).then(
        ([orderHeads, orderDetails]) => {
          dispatch(orderHeadsLoaded(orderHeads, timestamp));
          dispatch(orderDetailsLoaded(orderDetails, timestamp));
        }
      );
    }

    allRequestsPromise
      .catch((error) => dispatch(failure(JSON.stringify(error))))
      .finally(() => {
        dispatch(
          cacheRefresherActions.removeRequestInProgress(
            orderConstants.GET_ORDERS
          )
        );
        dispatch(
          loadingActions.removeLoadingInProgress(orderConstants.GET_ORDERS)
        );
      });
  };

  function orderHeadsLoaded(orderHeads, timestamp) {
    return {
      type: orderConstants.GET_ORDERS_ORDERHEADS_LOADED,
      orderHeads,
      timestamp,
    };
  }
  function orderDetailsLoaded(orderDetails, timestamp) {
    return {
      type: orderConstants.GET_ORDERS_DETAILS_LOADED,
      orderDetails,
      timestamp,
    };
  }
  function failure(error) {
    return { type: orderConstants.GET_ORDERS_FAILURE, error };
  }
}

export function getOrdersRequest() {
  return (dispatch) => {
    const timestamp = Date.now();
    dispatch(orderDetailsRequest(timestamp));
  };
  function orderDetailsRequest(timestamp) {
    return {
      type: orderConstants.GET_ORDERS_REQUEST,
      timestamp,
    };
  }
}

export function getOrderDetails(orderId, ignoreCache = false, silent = false) {
  const timestamp = Date.now();

  return (dispatch) => {
    dispatch(
      cacheRefresherActions.addRequestInProgress(
        orderConstants.GET_ORDER_DETAILS
      )
    );
    if (!silent) {
      dispatch(
        loadingActions.addLoadingInProgress(orderConstants.GET_ORDER_DETAILS)
      );
    }

    dispatch(
      cacheRefresherActions.setCacheRefreshFilter({
        orderId,
        requestType: cacheRefresherConstants.REQUEST_TYPE_ORDER_DETAILS,
      })
    );
    return OrdersService.getOrderDetails(orderId, ignoreCache)
      .then(
        (order) => dispatch(success(order, timestamp)),
        (error) => dispatch(failure(JSON.stringify(error)))
      )
      .finally(() => {
        dispatch(
          cacheRefresherActions.removeRequestInProgress(
            orderConstants.GET_ORDER_DETAILS
          )
        );
        dispatch(
          loadingActions.removeLoadingInProgress(
            orderConstants.GET_ORDER_DETAILS
          )
        );
      });
  };

  function success(order) {
    return { type: orderConstants.GET_ORDER_DETAILS_SUCCESS, order, timestamp };
  }

  function failure(error) {
    return { type: orderConstants.GET_ORDER_DETAILS_FAILURE, error };
  }
}

export function setSelectedOrder(order) {
  return (dispatch) => {
    dispatch(success(order));
  };

  function success(order) {
    return { type: orderConstants.SET_SELECTED_ORDER, order };
  }
}

export function getAllFractions(ignoreCache = false, silent = false) {
  return (dispatch) => {
    if (!silent) {
      dispatch(
        loadingActions.addLoadingInProgress(
          orderConstants.GET_ALL_FRACTIONS_REQUEST
        )
      );
    }
    return FractionService.getAllFractions(ignoreCache)
      .then(
        (fractions) => dispatch(success(fractions)),
        (error) => dispatch(failure(error))
      )
      .finally(() => {
        dispatch(
          loadingActions.removeLoadingInProgress(
            orderConstants.GET_ALL_FRACTIONS_REQUEST
          )
        );
      });
  };
  function success(fractions) {
    return { type: orderConstants.GET_ALL_FRACTIONS_SUCCESS, fractions };
  }

  function failure(error) {
    return { type: orderConstants.GET_ALL_FRACTIONS_FAILED, error };
  }
}

export function getOverView(
  fromDate,
  toDate,
  ignoreCache = true,
  silent = false
) {
  const timestamp = Date.now();

  return (dispatch) => {
    dispatch(
      cacheRefresherActions.addRequestInProgress(
        orderConstants.GET_ORDER_OVERVIEW
      )
    );
    if (!silent) {
      dispatch(
        loadingActions.addLoadingInProgress(orderConstants.GET_ORDER_OVERVIEW)
      );
    }

    return OrdersService.getOrderOverview(fromDate, toDate, ignoreCache)
      .then(
        (orderOverview) => dispatch(success(orderOverview, timestamp)),
        (error) => dispatch(failure(JSON.stringify(error)))
      )
      .finally(() => {
        dispatch(
          cacheRefresherActions.removeRequestInProgress(
            orderConstants.GET_ORDER_OVERVIEW
          )
        );
        dispatch(
          loadingActions.removeLoadingInProgress(
            orderConstants.GET_ORDER_OVERVIEW
          )
        );
      });
  };
  function success(orderOverview) {
    return {
      type: orderConstants.GET_ORDER_OVERVIEW_SUCCESS,
      orderOverview,
      timestamp,
    };
  }

  function failure(error) {
    return { type: orderConstants.GET_ORDER_OVERVIEW_FAILURE, error };
  }
}

export function setOrderoverviewFilter(filter) {
  return (dispatch) => {
    dispatch(setFilter(filter));
  };
  function setFilter(filter) {
    return {
      type: orderConstants.SET_ORDER_OVERVIEW_FILTER,
      filter,
    };
  }
}

export function setOrderCalendarFilter(filter) {
  return (dispatch) => {
    dispatch(setFilter(filter));
  };
  function setFilter(filter) {
    return {
      type: orderConstants.SET_ORDER_CALENDAR_FILTER,
      filter,
    };
  }
}

export function getOrderStatuses(ignoreCache = false) {
  return (dispatch) => {
    dispatch(
      loadingActions.addLoadingInProgress(orderConstants.GET_ORDER_STATUSES)
    );
    return OrdersService.getOrderStatuses(ignoreCache)
      .then(
        (statuses) => dispatch(success(statuses)),
        (error) => dispatch(failure(JSON.stringify(error)))
      )
      .finally(() => {
        dispatch(
          loadingActions.removeLoadingInProgress(
            orderConstants.GET_ORDER_STATUSES
          )
        );
      });
  };
  function success(statuses) {
    return {
      type: orderConstants.GET_ORDER_STATUSES_SUCCES,
      statuses,
    };
  }

  function failure(error) {
    return { type: orderConstants.GET_ORDER_STATUSES_FAILRE, error };
  }
}

export function setCalendarMonth(date) {
  return (dispatch) => {
    dispatch(setDate(date));
  };
  function setDate(date) {
    return {
      type: orderConstants.SET_CALENDAR_MONTH,
      date,
    };
  }
}

export function setOverviewView(isCalendarVisible) {
  return (dispatch) => {
    dispatch(setCalendarVisibility(isCalendarVisible));
  };
  function setCalendarVisibility(isCalendarVisible) {
    return {
      type: orderConstants.SET_CALENDAR_VISIBILITY,
      isCalendarVisible,
    };
  }
}

export function setCalenderView(calendarView) {
  return (dispatch) => {
    dispatch(setCalendarView(calendarView));
  };
  function setCalendarView(calendarView) {
    return {
      type: orderConstants.SET_CALENDAR_VIEW,
      calendarView,
    };
  }
}
